// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Row button ───────────────────────────────────────────── */
.photo-btn { position: relative; }
.photo-btn.has-photos { color: var(--accent-light); }
.photo-btn-count {
  position: absolute;
  top: -2px; right: -3px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  color: var(--accent-light);
}
/* No photos: only visible on row hover / focus (always faintly on touch screens) */
.photo-btn-empty { opacity: 0; }
tr:hover .photo-btn-empty,
tr.row-editing .photo-btn-empty,
.photo-btn-empty:focus-visible { opacity: 0.55; }
.photo-btn-empty:hover { opacity: 1; }
@media (hover: none) { .photo-btn-empty { opacity: 0.35; } }

/* ── Gallery modal ────────────────────────────────────────── */
.photo-backdrop {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

.photo-modal {
  width: min(1100px, 94vw);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  overflow: hidden;
}

.photo-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px 8px 14px;
  border-bottom: 1px solid var(--border);
}
.photo-title { font-size: 13px; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.photo-count { font-size: 12px; color: var(--text-muted); white-space: nowrap; }
.photo-add-btn { display: flex; align-items: center; gap: 4px; white-space: nowrap; }

.photo-stage {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}
.photo-stage img {
  max-width: 100%;
  max-height: calc(92vh - 190px);
  object-fit: contain;
  display: block;
}

.photo-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.photo-nav:hover { background: rgba(0, 0, 0, 0.6); }
.photo-nav-prev { left: 8px; }
.photo-nav-next { right: 8px; }

.photo-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 6px 14px;
  border-top: 1px solid var(--border);
}
.photo-meta-text { flex: 1; font-size: 12px; color: var(--text-secondary); }

.photo-thumbs {
  display: flex;
  gap: 6px;
  padding: 8px 10px;
  overflow-x: auto;
  border-top: 1px solid var(--border);
}
.photo-thumb {
  flex-shrink: 0;
  width: 64px;
  height: 48px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 3px;
  overflow: hidden;
  background: #000;
  cursor: pointer;
  opacity: 0.7;
}
.photo-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.photo-thumb:hover { opacity: 1; }
.photo-thumb.active { border-color: var(--accent-light); opacity: 1; }

.photo-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 60px 20px;
  color: var(--text-muted);
  font-size: 13px;
}

@media (max-width: 768px) {
  .photo-modal { width: 100vw; max-height: 100vh; height: 100%; border-radius: 0; border: none; }
  .photo-stage img { max-height: calc(100vh - 190px); }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PhotoGallery.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE,aAAa,kBAAkB,EAAE;AACjC,wBAAwB,0BAA0B,EAAE;AACpD;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA,mFAAmF;AACnF,mBAAmB,UAAU,EAAE;AAC/B;;iCAEiC,aAAa,EAAE;AAChD,yBAAyB,UAAU,EAAE;AACrC,uBAAuB,mBAAmB,aAAa,EAAE,EAAE;;AAE3D,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;AACxC;AACA,eAAe,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC9I,eAAe,eAAe,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AAC/E,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAEpF;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,SAAS,EAAE;AAC7B,kBAAkB,UAAU,EAAE;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mCAAmC;AACrC;AACA,mBAAmB,OAAO,EAAE,eAAe,EAAE,4BAA4B,EAAE;;AAE3E;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjF,qBAAqB,UAAU,EAAE;AACjC,sBAAsB,iCAAiC,EAAE,UAAU,EAAE;;AAErE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe,YAAY,EAAE,iBAAiB,EAAE,YAAY,EAAE,gBAAgB,EAAE,YAAY,EAAE;EAC9F,mBAAmB,+BAA+B,EAAE;AACtD","sourcesContent":["/* ── Row button ───────────────────────────────────────────── */\n.photo-btn { position: relative; }\n.photo-btn.has-photos { color: var(--accent-light); }\n.photo-btn-count {\n  position: absolute;\n  top: -2px; right: -3px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--accent-light);\n}\n/* No photos: only visible on row hover / focus (always faintly on touch screens) */\n.photo-btn-empty { opacity: 0; }\ntr:hover .photo-btn-empty,\ntr.row-editing .photo-btn-empty,\n.photo-btn-empty:focus-visible { opacity: 0.55; }\n.photo-btn-empty:hover { opacity: 1; }\n@media (hover: none) { .photo-btn-empty { opacity: 0.35; } }\n\n/* ── Gallery modal ────────────────────────────────────────── */\n.photo-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 300;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n}\n\n.photo-modal {\n  width: min(1100px, 94vw);\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.photo-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px 8px 14px;\n  border-bottom: 1px solid var(--border);\n}\n.photo-title { font-size: 13px; font-weight: 600; color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.photo-count { font-size: 12px; color: var(--text-muted); white-space: nowrap; }\n.photo-add-btn { display: flex; align-items: center; gap: 4px; white-space: nowrap; }\n\n.photo-stage {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n}\n.photo-stage img {\n  max-width: 100%;\n  max-height: calc(92vh - 190px);\n  object-fit: contain;\n  display: block;\n}\n\n.photo-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.35);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.photo-nav:hover { background: rgba(0, 0, 0, 0.6); }\n.photo-nav-prev { left: 8px; }\n.photo-nav-next { right: 8px; }\n\n.photo-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px 6px 14px;\n  border-top: 1px solid var(--border);\n}\n.photo-meta-text { flex: 1; font-size: 12px; color: var(--text-secondary); }\n\n.photo-thumbs {\n  display: flex;\n  gap: 6px;\n  padding: 8px 10px;\n  overflow-x: auto;\n  border-top: 1px solid var(--border);\n}\n.photo-thumb {\n  flex-shrink: 0;\n  width: 64px;\n  height: 48px;\n  padding: 0;\n  border: 2px solid transparent;\n  border-radius: 3px;\n  overflow: hidden;\n  background: #000;\n  cursor: pointer;\n  opacity: 0.7;\n}\n.photo-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\n.photo-thumb:hover { opacity: 1; }\n.photo-thumb.active { border-color: var(--accent-light); opacity: 1; }\n\n.photo-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 60px 20px;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n@media (max-width: 768px) {\n  .photo-modal { width: 100vw; max-height: 100vh; height: 100%; border-radius: 0; border: none; }\n  .photo-stage img { max-height: calc(100vh - 190px); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
